/* eslint-disable @typescript-eslint/no-non-null-assertion */
interface ImageMap {
	[key: string]: string;
}

const devOpsSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/dam/jcr:02632bb4-e70f-4f9b-94f9-b28d2d58ae3a/devops-diagram_de-DE.png?cdnVersion=1392',
	es: 'https://wac-cdn.atlassian.com/dam/jcr:6a5891b0-9d7e-4411-878a-ad76dac1653a/devops-diagram_es-ES.png?cdnVersion=1392',
	fr: 'https://wac-cdn.atlassian.com/dam/jcr:d4dcc1d3-4c05-40cb-a04c-466a26e71ec2/devops-diagram_fr-FR.png?cdnVersion=1392',
	br: 'https://wac-cdn.atlassian.com/dam/jcr:a9dbb9ee-0009-434b-a0f4-e99f48508a37/devops-diagram_pt-BR.png?cdnVersion=1392',
	en: 'https://wac-cdn.atlassian.com/dam/jcr:c11e57a5-86cc-42b9-afa3-d77e1733d092/devops-diagram.svg?cdnVersion=1392',
	ja: 'https://wac-cdn.atlassian.com/dam/jcr:24b84f80-3c90-4d5b-acc6-7dc791de57b9/devops-diagram_ja-JP.png?cdnVersion=1392',
	ru: 'https://wac-cdn.atlassian.com/dam/jcr:a45d0330-3a7d-489a-a774-cc8590076601/devops-diagram_ru-RU.png?cdnVersion=1392',
};

export const getDevOpsSectionImage = (locale: string): string => {
	return devOpsSectionImageMap[locale] || devOpsSectionImageMap['en']!;
};

const dragAndDropSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/dam/jcr:57415379-cdd9-473d-970a-2d0a2f0cac4e/automation-string%20DE.svg',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string.webp',
	en: 'https://wac-cdn.atlassian.com/dam/jcr:d2a791e4-24ca-41cb-b5de-ca6df4e67c0a/automation-string.svg',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-RU.webp',
};

export const getDragAndDropSectionImage = (locale: string): string => {
	return dragAndDropSectionImageMap[locale] || dragAndDropSectionImageMap['en']!;
};

const reportsAndInsightsSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_DE.webp',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_pt-BR.webp',
	en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights.webp',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_RU.webp',
};

export const getReportsAndInsightsSectionImage = (locale: string): string => {
	return reportsAndInsightsSectionImageMap[locale] || reportsAndInsightsSectionImageMap['en']!;
};

const viewRepositoriesSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_DE.webp',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ptBR.webp',
	en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-one.webp',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_RU.webp',
};

export const getViewRepositoriesSectionImage = (locale: string): string => {
	return viewRepositoriesSectionImageMap[locale] || viewRepositoriesSectionImageMap['en']!;
};

const featureCoordinateSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_DE.webp',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ptBR.webp',
	en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-two.webp',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_RU.webp',
};

export const getFeatureCoordinateSectionImage = (locale: string): string => {
	return featureCoordinateSectionImageMap[locale] || featureCoordinateSectionImageMap['en']!;
};

const featureConnectWorkSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_DE.webp',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ptBR.webp',
	en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/feature-code-image-three.webp',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_RU.webp',
};

export const getFeatureConnectWorkSectionImage = (locale: string): string => {
	return featureConnectWorkSectionImageMap[locale] || featureConnectWorkSectionImageMap['en']!;
};

const scrumSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_DE.webp',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ptBR.webp',
	en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-scrum_board@2x.webp',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_RU.webp',
};

export const getScrumSectionImage = (locale: string): string => {
	return scrumSectionImageMap[locale] || scrumSectionImageMap['en']!;
};

const kanbanSectionImageMap: ImageMap = {
	de: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_DE.webp',
	es: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ES.webp',
	fr: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_FR.webp',
	br: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ptBR.webp',
	en: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-kanban_board@2x.webp',
	ja: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_JA.webp',
	ru: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_RU.webp',
};

export const getKanbanSectionImage = (locale: string): string => {
	return kanbanSectionImageMap[locale] || kanbanSectionImageMap['en']!;
};
